import functions from "../util/functions";

const banco = functions.databaseConfig();

const reqFuncionario = {
	listar: function (api, nome, ativo) {
		return api
			.get("v1/gestor/funcionario", {
				params: {
					nome: nome + "%",
					ativo: ativo + "%",
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqFuncionario;
